import { useMessageContext } from '../../modules/Message'
// import BotMessageActions from './BotMessageActions'
import UserMessageActions from './UserMessageActions'

export default function MessageActions() {
	const { message } = useMessageContext()

	if (message.role !== 'user') {
		return
	}

	return (
		<UserMessageActions />
	)
}
